import { Chip } from '@mui/material'
import { LifecycleState } from 'src/v3/core/types'

type Props = {
  lifecycleState: LifecycleState | undefined
  size?: 'small' | 'medium'
}

let LifecycleChip = ({ lifecycleState, size = 'small' }: Props) => {
  if (lifecycleState === 'preArchive') {
    return <Chip color="warning" label="Pre-archive" size={size} />
  }
  if (lifecycleState === 'archive') {
    return <Chip color="default" label="Archived" size={size} />
  }
  return null
}

export default LifecycleChip
